import { c as _c } from "react/compiler-runtime";
import { ClickAwayListener } from "@mui/material";
import React, { useState } from "react";
import { FieldValues, UseFormRegister, UseFormSetValue } from "react-hook-form";
import { twMerge } from "tailwind-merge";
import ChooseEventDatePicker from "@/app/(main)/(club)/mes-clubs/[id]/components/choose-event-date-picker";
import HocTextInput from "@/components/global/inputs/hoc-text-input";
import TextInput from "@/components/global/inputs/text-input";
import useMobile from "@/hooks/use-mobile";
function ChooseEventDatePickerInput(t0) {
  const $ = _c(35);
  const {
    loading,
    register,
    clubSlug,
    setValue,
    mobileSize,
    label: t1,
    needed: t2,
    required: t3,
    alreadyInvitedDates
  } = t0;
  const label = t1 === undefined ? "Date de la r\xE9union" : t1;
  const needed = t2 === undefined ? false : t2;
  const required = t3 === undefined ? false : t3;
  let t4;
  if ($[0] !== loading || $[1] !== register) {
    t4 = HocTextInput(TextInput, loading, register);
    $[0] = loading;
    $[1] = register;
    $[2] = t4;
  } else {
    t4 = $[2];
  }
  const EnhancedTextInput = t4;
  const handleClickAway = () => {
    setIsHere(false);
  };
  let desactiveMobile = true;
  if (mobileSize) {
    desactiveMobile = false;
  }
  const isMobile = useMobile(mobileSize, desactiveMobile);
  const [isHere, t5] = useState(false);
  const setIsHere = t5;
  const t6 = isHere ? "gap-8" : "gap-0";
  let t7;
  if ($[3] !== t6) {
    t7 = twMerge("w-full flex flex-col relative", t6);
    $[3] = t6;
    $[4] = t7;
  } else {
    t7 = $[4];
  }
  let t8;
  if ($[5] !== setIsHere) {
    t8 = () => setIsHere(true);
    $[5] = setIsHere;
    $[6] = t8;
  } else {
    t8 = $[6];
  }
  let t9;
  if ($[7] !== EnhancedTextInput || $[8] !== isHere || $[9] !== label || $[10] !== needed || $[11] !== required || $[12] !== setIsHere) {
    t9 = <EnhancedTextInput setIsHere={setIsHere} isHere={isHere} labelClassName="font-bold uppercase" needed={needed} required={required} label={label} name="dayofmonth" placeholder={"S\xE9lectionner une date"} className="capitalize" autocomplete="off" />;
    $[7] = EnhancedTextInput;
    $[8] = isHere;
    $[9] = label;
    $[10] = needed;
    $[11] = required;
    $[12] = setIsHere;
    $[13] = t9;
  } else {
    t9 = $[13];
  }
  let t10;
  if ($[14] !== t8 || $[15] !== t9) {
    t10 = <a className="inset-0 cursor-pointer relative z-10" onClick={t8}>{t9}</a>;
    $[14] = t8;
    $[15] = t9;
    $[16] = t10;
  } else {
    t10 = $[16];
  }
  const t11 = isMobile ? "flex relative justify-center translate-x-0 right-0 w-full" : "absolute";
  let t12;
  if ($[17] !== t11) {
    t12 = twMerge("absolute pl-4 right-0 translate-x-full w-80", t11);
    $[17] = t11;
    $[18] = t12;
  } else {
    t12 = $[18];
  }
  let t13;
  if ($[19] !== alreadyInvitedDates || $[20] !== clubSlug || $[21] !== isHere || $[22] !== setIsHere || $[23] !== setValue) {
    t13 = <ChooseEventDatePicker setValue={setValue} isHere={isHere} setIsHere={setIsHere} clubSlug={clubSlug} alreadyInvitedDates={alreadyInvitedDates} />;
    $[19] = alreadyInvitedDates;
    $[20] = clubSlug;
    $[21] = isHere;
    $[22] = setIsHere;
    $[23] = setValue;
    $[24] = t13;
  } else {
    t13 = $[24];
  }
  let t14;
  if ($[25] !== t12 || $[26] !== t13) {
    t14 = <div className={t12}>{t13}</div>;
    $[25] = t12;
    $[26] = t13;
    $[27] = t14;
  } else {
    t14 = $[27];
  }
  let t15;
  if ($[28] !== t10 || $[29] !== t14 || $[30] !== t7) {
    t15 = <div className={t7}>{t10}{t14}</div>;
    $[28] = t10;
    $[29] = t14;
    $[30] = t7;
    $[31] = t15;
  } else {
    t15 = $[31];
  }
  let t16;
  if ($[32] !== handleClickAway || $[33] !== t15) {
    t16 = <ClickAwayListener onClickAway={handleClickAway}>{t15}</ClickAwayListener>;
    $[32] = handleClickAway;
    $[33] = t15;
    $[34] = t16;
  } else {
    t16 = $[34];
  }
  return t16;
}
export default ChooseEventDatePickerInput;